export enum BoolFilterKey {
  Undefined = 'undefined',
  True = 'true',
  False = 'false',
}

export const boolFilterToKey = (value?: boolean): BoolFilterKey => {
  return value === undefined ? BoolFilterKey.Undefined : (`${value}` as BoolFilterKey);
};

export const keyToBoolFilter = (key: BoolFilterKey) => {
  switch (key) {
    case BoolFilterKey.False:
      return false;
    case BoolFilterKey.True:
      return true;
    case BoolFilterKey.Undefined:
    default:
      return undefined;
  }
};

export const checkHasFilters = <T extends Record<string, unknown>>(
  filters?: T,
  defaultState?: T,
  disabledKeys?: (keyof T)[],
) => {
  if (!filters || !defaultState) return false;

  return Object.keys(filters)
    .filter((key) => !disabledKeys?.includes(key as keyof T))
    .some((key) => {
      const typedKey = key as keyof T;

      if (Array.isArray(filters[typedKey])) {
        return !!(filters[typedKey] as unknown[]).length;
      }

      return filters[typedKey] !== defaultState[typedKey];
    });
};
